// extracted by mini-css-extract-plugin
export var legendIndicator = "_bn-1";
export var legendRight = "_bn-0";